import React from 'react';
import { View, StyleSheet, TextInput } from 'react-native';
import { Typography } from '../ui';
import { useTheme } from '../../context/ThemeContext';
import type { JournalEntryDraft, JournalPrompts } from '../../types/auth';

interface Props {
  prompts: JournalPrompts;
  draft: JournalEntryDraft;
  onChange: (field: string, value: string) => void;
  /** Префикс testID: окно рефлексии и правка записи проверяются раздельно. */
  testIDPrefix?: string;
}

/**
 * CORE-1751 — поля записи: вопросы с сервера и свободная форма.
 *
 * Вынесены из окна рефлексии, потому что ровно те же поля нужны правке записи
 * в «Моих записях». Второй экземпляр разошёлся бы с первым на первой же правке
 * вопросов — а вопросы правит продукт, без выката приложений.
 */
export function ReflectionFields({ prompts, draft, onChange, testIDPrefix = 'reflection-field' }: Props) {
  const { colors } = useTheme();
  const values = draft as Record<string, string | undefined>;
  return (
    <>
      {prompts.prompts.map((prompt) => (
        <View key={prompt.field} style={styles.field}>
          <Typography variant="body" style={[styles.question, { color: colors.textPrimary }]}>
            {prompt.textRu}
          </Typography>
          <TextInput
            testID={`${testIDPrefix}-${prompt.field}`}
            value={values[prompt.field] ?? ''}
            onChangeText={(value) => onChange(prompt.field, value)}
            multiline
            style={[styles.input, { color: colors.textPrimary, borderColor: colors.border }]}
            placeholderTextColor={colors.textSecondary}
          />
        </View>
      ))}

      <View style={styles.field}>
        <Typography variant="body" style={[styles.question, { color: colors.textPrimary }]}>
          {prompts.freeFormHint}
        </Typography>
        <TextInput
          testID={`${testIDPrefix}-freeForm`}
          value={draft.freeForm ?? ''}
          onChangeText={(value) => onChange('freeForm', value)}
          multiline
          style={[styles.input, styles.inputTall, { color: colors.textPrimary, borderColor: colors.border }]}
          placeholderTextColor={colors.textSecondary}
        />
      </View>
    </>
  );
}

const styles = StyleSheet.create({
  field: { gap: 6 },
  question: { lineHeight: 21 },
  input: {
    borderWidth: 1, borderRadius: 12, padding: 12,
    minHeight: 64, textAlignVertical: 'top',
  },
  inputTall: { minHeight: 96 },
});
